import { render, staticRenderFns } from "./TheProfileSidebar.vue?vue&type=template&id=5aae0c26&"
import script from "./TheProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./TheProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheProfileSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports